interface IProps {
  error?: any;
}

// Validation message shown between the label and the field. Placed above (not below) the field
// so inputs in a row stay aligned, since columns are bottom-aligned (.row .col { align-self: end }).
const FieldError = ({ error }: IProps) => {
  if (!error?.message) return null;
  return <div className="fieldError">{error.message.toString()}</div>;
};

export default FieldError;
